import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'CombineMultipleAuthorsName'
})
export class CombineMultipleAuthorsNamePipe implements PipeTransform {

  transform(authors: Array<any>, args?: any): any {
    let str = '';
    authors.forEach((author, idx) => {
      str += `${author.firstName} ${author.lastName}`;
      if ((authors.length - 1) != idx)
        str += ' , ';
    });
    return str;
  }
}
